export default __webpack_public_path__ + "static/media/day8.479ddd37.png";